import { React, Typography } from 'uweb'
import { THREE } from 'uweb/three'
import { Coordinate, UTM } from 'uweb/utils'
import { MapView, maptalks } from 'uweb/maptalks'
import { CloseCircleOutlined } from '@ant-design/icons'
import { log, KeyValue, Safe } from 'utils/web'
import moment from 'moment'
const { Paragraph } = Typography

export class AreaTool {

    Maptalks: MapView
    cfg: iArgs
    tool: any

    constructor(Maptalks: MapView, cfg: iArgs, message: any) {

        const als = `tool.area`
        this.Maptalks = Maptalks
        this.cfg = cfg

        const { event } = cfg

        this.setup()

        const close = () => {
            if (this.tool.isEnabled()) {
                message.destroy(als)
                this.tool.clear()
                this.tool.disable()
                event.emit('map:edit', false)
            }
        }

        event.on(`${als}.enable`, (n) => {

            event.emit('tools.close', true)

            message.open({
                key: als,
                top: 100,
                duration: 0,
                content: <Paragraph
                    style={{ padding: 0, margin: 0 }}
                    copyable={{ icon: <CloseCircleOutlined />, tooltips: ['Close', 'Closed'], onCopy: () => close() }}
                >Area Tool</Paragraph>
            })

            this.tool.enable()
            event.emit('map:edit', true)

        })

        event.on(`${als}.disable`, (n) => this.tool.disable())
        event.on('tools.close', () => close())

    }

    setup = () => {

        this.tool = new maptalks.AreaTool({

            'language': 'en-US',
            'symbol': {
                'lineColor': '#1bbc9b',
                'lineWidth': 2,
                'polygonFill': '#fff',
                'polygonOpacity': 0.3
            },
            'vertexSymbol': {
                'markerType': 'ellipse',
                'markerFill': '#34495e',
                'markerLineColor': '#1bbc9b',
                'markerLineWidth': 3,
                'markerWidth': 10,
                'markerHeight': 10
            },
            'labelOptions': {
                'textSymbol': {
                    'textFaceName': 'monospace',
                    'textFill': '#fff',
                    'textLineSpacing': 1,
                    'textHorizontalAlignment': 'right',
                    'textDx': 15
                },
                'boxStyle': {
                    'padding': [6, 2],
                    'symbol': {
                        'markerType': 'square',
                        'markerFill': '#000',
                        'markerFillOpacity': 0.5,
                        'markerLineColor': '#b4b3b3'
                    }
                }
            },
            'clearButtonSymbol': [{
                'markerType': 'square',
                'markerFill': '#000',
                'markerLineColor': '#b4b3b3',
                'markerLineWidth': 2,
                'markerWidth': 15,
                'markerHeight': 15,
                'markerDx': 22
            }, {
                'markerType': 'x',
                'markerWidth': 10,
                'markerHeight': 10,
                'markerLineColor': '#fff',
                'markerDx': 22
            }],

        }).addTo(this.Maptalks.map).disable()

        this.tool.on('drawend', (param: any) => {

            Safe(() => {

                const zone = KeyValue('Zone')
                const is_3D_diff = Number(KeyValue('Elevation'))
                const { geometry: { coordinates } } = param.geometry.toGeoJSON()
                const area = param.geometry.getArea()
                const df = `YYYY-MM-DD HH:mm`
                const fromDate = moment().add(-(24 * 7), 'hours').format(df)
                const toDate = moment().format(df)
                const polygon = coordinates[0].map(([x, y]: any) => {
                    const { Easting, Northing } = UTM.convertLatLngToUtm(y, x, 2)
                    return [Easting, Northing, 0]
                })

                const viewOptions = [
                    {
                        id: 0,
                        name: 'Points',
                        channel: 'core_collect',
                        path: 'find-points',
                        view: 'ViewAsPoints',
                    },
                    {
                        id: 1,
                        name: 'Surface',
                        channel: 'core_collect',
                        path: 'surface-points',
                        view: 'ViewAsSurface',
                    },
                    {
                        id: 2,
                        name: 'Mesh',
                        channel: 'core_collect',
                        path: 'mesh-points',
                        view: 'ViewAsMesh',
                    },
                ]

                const explore: iExplorer = {
                    name: `Area ${area.toFixed(0)}m²`,
                    queries: [
                        {
                            query: {
                                Type: 'status',
                                Prefix: '',
                                Polygon: polygon,
                                Elevation: { x: is_3D_diff - 20, y: is_3D_diff + 5 },
                                Start: fromDate,
                                End: toDate,
                            },
                            update: {},
                            hide: ['Type', 'Prefix', 'Polygon'],
                            pane: {
                                RTK: true,
                                Vehicles: '*',
                                View: viewOptions[0], _View: viewOptions,
                            },
                        }
                    ],
                }

                this.cfg.event.emit('explorer', explore)

            }, `[AREA.TOOL]`)

        })

    }

}